export enum CommissionType {
	NONE = 0,
	COMMISSION = 1,
	BONUS = 2
}
